<template>
  <div v-if="isLoaded" class="page-grid">
    <StatusBar :farm="farm"></StatusBar>

    <div class="selected-research">
      <ResearchCard v-if="lab.researchById(selectedResearch) !== undefined && lab.researchIsVisible(lab.researchById(selectedResearch))"
                    :research="lab.researchById(selectedResearch)" :farm="farm" />
      <div v-else class="no-selected">
        <h1>Select a research</h1>
      </div>
    </div>
    <div class="farm-window thumb-list-border available">
      <h3>Available</h3>
      <div class="thumb-list">
        <template v-for="research in lab.available">
          <img class="research-thumb"
               :src="research.image"
               @click="this.selectResearch(research)"
               :class="{ 'selected-thumb': this.selectedResearch === research.id }"
               :title="research.name"
               ondragstart="return false"
          />
        </template>
      </div>
    </div>
    <div class="farm-window thumb-list-border completed">
      <h3>Completed</h3>
      <div class="thumb-list">
        <template v-for="research in lab.completed">
          <img class="research-thumb"
               :src="research.image"
               @click="this.selectResearch(research);"
               :class="{ 'selected-thumb': this.selectedResearch === research.id }"
               :title="research.name"
               ondragstart="return false"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import Laboratory from '@/farm/Laboratory'
import ResearchCard from '@/components/ResearchCard.vue'
import Research from '@/Research'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'
import StatusBar from '@/components/StatusBar.vue'

@Options({
  components: {
    ResearchCard, ValueMeter, FarmStatusCard, TextButton, StatusBar
  },
  props: {
    farm: Object
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    selectResearch(research: Research) {
      this.selectedResearch = research.id
    },
    util() {
      return util
    }
  },
  emits: ['close'],
  computed: {
    lab: function () {
      return this.farm.state.lab
    }
  },
  async created() {
    this.selectedResearch = ''
    this.isLoaded = true
  },
  activated() {
    this.$forceUpdate() // Not sure if this is needed anymore
  }
})
export default class LabView extends Vue {
  isLoaded = false
  farm!: Farm
  selectedResearch: string = ''
}
</script>

<style scoped lang="scss">
  .page-grid {
    height: auto;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas:
        "s s"
        "r r"
        "a a"
        "c c";

    @media screen and (max-width: $mobile-width){
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto;
      grid-template-areas:
          "s"
          "r"
          "a"
          "c";
    }
  }

  .status-bar {
    grid-area: s;
  }

  .selected-research {
    grid-area: r;

    box-sizing: border-box;
    width: 100%;
    max-width: $main-column-max-width;
    margin: auto;
  }

  .available {
    grid-area: a;

    box-sizing: border-box;
    width: 100%;
    max-width: $main-column-max-width;
    margin: auto;
  }

  .completed {
    grid-area: c;

    box-sizing: border-box;
    width: 100%;
    max-width: $main-column-max-width;
    margin: auto;
  }

  h2 {
    text-align: left;
  }

  .thumb-list {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fill, 100px);
    grid-auto-rows: 1fr;
    justify-content: center;
    margin-left: auto; // Center component
    margin-right: auto; // Center component
    background-color: $component-background-color;
    border: 1px solid black;
    padding: 5px;
    min-height: 100px;

    .research-thumb {
      width: 100px;
      height: 100px;
      border: 1px solid black;
      background: $research-thumb-background;
      //margin: 5px;

      transition: border $selection-time;
      &:hover {
        border: 1px solid $highlight-color;
      }
    }

    .selected-thumb {
      border: 1px solid $highlight-color;
    }
  }

  img {
    max-width: 200px;
    user-select: none;
  }
</style>
